
import axios from 'axios'
import { ENV, APPKEY } from 'public/config'
import { collectApiMap, getToken, md5Http } from 'public/utils'

// 获取公共参数
import { reportEvent, commonParams } from './report-event'


const MaxLongTaskList = 10
const MaxTimeout = 2000
let timeoutId = ''
let reportList = []


const BaseUrl = collectApiMap[ENV] || collectApiMap['uat']


function http (obj = {}) {
  if (!obj.data) {
    return
  }
  const commomReportData = commonParams()
  const data = obj.data.map(ele => ({...ele, ...commomReportData}))
  console.info('[component-report] 打印组件埋点上报的数据', data)
  let token = getToken()
  let now = Date.now()
  axios({
    method: 'post',
    url: BaseUrl + '?cts.webComponent.uploadLog',
    data,
    headers: {
      format: 'JSON',
      method: 'cts.webComponent.uploadLog',
      appkey: APPKEY['cts'],
      token,
      timestamp: now,
      sign: md5Http(token, now, data),
      'X-Env': ENV || 'uat'
    }
  })
}

function send () {
  if (!reportList.length) {
    return
  }
  http({data: reportList})
  reportList = []
}

function checkAndSend() {
  clearTimeout(timeoutId)
  if (reportList.length > MaxLongTaskList) {
    send()
  } else {
    timeoutId = setTimeout(function() {
      send()
    }, MaxTimeout)
  }
}

// 增加上报数据
export function httpReport (data) {
  const item = reportEvent(data)
  item && reportList.push(item)
  window.requestIdleCallback(checkAndSend)
}



// WEBPACK FOOTER //
// ./src/public/mixins/component-report/report.js